import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ css }) => {
  return {
    editCell: css`
      display: flex;
      justify-content: space-between;
    `,
    select: css`
      display: flex;
    `
  }
})
